import { Rental } from "../api";
import {
  showInnerLoading,
  setRentalValue,
} from "../actions";

export function getQuotation() {
  return function getQuote(dispatch, getState) {

    const { amount, isCompany, currencyCode } = getState().rental;
    const request = {
      monto: amount,
      empresa: isCompany ? '1' : '0',
      codigoMoneda: currencyCode ? '1' : '0',
    };

    dispatch(showInnerLoading(true));

    return Rental.getQuotation(request).then(resQuotation => {
      if (resQuotation) {

        const { premio, premioRecargoCuotas, sueldoMinimo } = resQuotation;

        dispatch(setRentalValue('fixedAmount', amount));
        dispatch(setRentalValue('fixedCurrencyCode', currencyCode));

        dispatch(setRentalValue('prize', premio.toFixed(0)));
        dispatch(setRentalValue('prize6', (premio / 6).toFixed(0)));
        dispatch(setRentalValue('prize10', (premioRecargoCuotas / 10).toFixed(0)));
        dispatch(setRentalValue('minSalary', sueldoMinimo.toFixed(0)));

      } else {
        // console.log('Error GTIA ALQUILER');
      }

      dispatch(showInnerLoading(false));
    });
  };
}

export function sendMail() {
  return (dispatch, getState) => {
    const {
      applicants,
      occupation,
      jobTitle,
      jobYears,
      jobNetPay,
      jobNetPayCurrency,
      knownRealEstate,
      knownPropertyLocation,
      knownPropertyLocationText,
      monthlyRentalAmount,
      monthlyRentalAmountCurrency,
      companyName,
      companyRUT,
      knowUs,
      confidenceBroker,
      // confidenceBrokerName,
      workAddressState,
      workAddressCity,
      workAddressStreet,
      workAddressNumber,
      workAddressApto,
      attachments
    } = getState().rental;

    const applicant = applicants[0];
    const coApplicants = applicants.slice(1);

    const fileNames = attachments ? attachments.map(fileItem => fileItem.file) : [];
    const base64StringArray = attachments ? attachments.map(fileItem => fileItem.base64) : [];

    let reqCoApplicants = [];

    if (coApplicants.length) {
      reqCoApplicants = coApplicants.map(coApplicant => {
        return ({
          Name: coApplicant.name,
          FatherLastName: coApplicant.lastName,
          MotherLastName: coApplicant.motherLastName,
          Gender: coApplicant.gender.value,
          GenderText: coApplicant.gender.label,
          DocumentType: coApplicant.documentType.value,
          DocumentNumber: coApplicant.documentNumber,
          DateOfBirth: coApplicant.dateOfBirth,
          Nationality: coApplicant.nationality,
          CivilStatus: coApplicant.civilStatus.value,
          CivilStatusText: coApplicant.civilStatus.label,
          Department: coApplicant.addressState.value,
          DepartmentText: coApplicant.addressState.label,
          City: parseInt(coApplicant.addressCity.value, 10),
          CityText: coApplicant.addressCity.label,
          AddressName: parseInt(coApplicant.addressStreet.value, 10),
          AddressNameText: coApplicant.addressStreet.label,
          AddressNumber: parseInt(coApplicant.addressNumber, 10),
          AddressApto: coApplicant.addressApto,
          PhoneNumber: coApplicant.phoneNumber,
          MobileNumber: coApplicant.mobileNumber,
          Email: coApplicant.email,

          JobSituation: coApplicant.occupation.value,
          JobSituationText: coApplicant.occupation.label,
          CompanyName: coApplicant.companyName,
          Rut: coApplicant.companyRUT,
          CompanyDepartment: coApplicant.workAddressState ? parseInt(coApplicant.workAddressState.value, 10) : 0,
          CompanyDepartmentText: coApplicant.workAddressState ? coApplicant.workAddressState.label : '',
          CompanyCity: coApplicant.workAddressCity ? parseInt(coApplicant.workAddressCity.value, 10) : 0,
          CompanyCityText: coApplicant.workAddressCity ? coApplicant.workAddressCity.label : '',
          CompanyAddressName: coApplicant.workAddressStreet ? parseInt(coApplicant.workAddressStreet.value, 10) : 0,
          CompanyAddressNameText: coApplicant.workAddressStreet ? coApplicant.workAddressStreet.label : '',
          CompanyAddressNumber: parseInt(coApplicant.workAddressNumber, 10),
          CompanyAddressApto: coApplicant.workAddressApto,
          JobTitle: coApplicant.jobTitle,
          JobYears: parseInt(coApplicant.jobYears, 10),
          JobNetPay: parseInt(coApplicant.jobNetPay, 10),
          JobNetPayPesos: coApplicant.jobNetPayCurrency ? 0 : 1
        })
      });
    }

    const request = {
      Applicant: {
        Name: applicant.name,
        FatherLastName: applicant.lastName,
        MotherLastName: applicant.motherLastName,
        Gender: applicant.gender.value,
        GenderText: applicant.gender.label,
        DocumentType: applicant.documentType.value,
        DocumentNumber: applicant.documentNumber,
        DateOfBirth: applicant.dateOfBirth,
        Nationality: applicant.nationality,
        CivilStatus: applicant.civilStatus.value,
        CivilStatusText: applicant.civilStatus.label,
        Department: applicant.addressState.value,
        DepartmentText: applicant.addressState.label,
        City: applicant.addressCity.value,
        CityText: applicant.addressCity.label,
        AddressName: applicant.addressStreet.value,
        AddressNameText: applicant.addressStreet.label,
        AddressNumber: applicant.addressNumber,
        AddressApto: applicant.addressApto,
        PhoneNumber: applicant.phoneNumber,
        MobileNumber: applicant.mobileNumber,
        Email: applicant.email,

        JobSituation: applicant.occupation.value,
        JobSituationText: applicant.occupation.label,
        CompanyName: applicant.companyName,
        Rut: applicant.companyRUT,
        CompanyDepartment: applicant.workAddressState ? parseInt(applicant.workAddressState.value, 10) : 0,
        CompanyDepartmentText: applicant.workAddressState ? applicant.workAddressState.label : '',
        CompanyCity: applicant.workAddressCity ? parseInt(applicant.workAddressCity.value, 10) : 0,
        CompanyCityText: applicant.workAddressCity ? applicant.workAddressCity.label : '',
        CompanyAddressName: applicant.workAddressStreet ? parseInt(applicant.workAddressStreet.value, 10) : 0,
        CompanyAddressNameText: applicant.workAddressStreet ? applicant.workAddressStreet.label : '',
        CompanyAddressNumber: parseInt(applicant.workAddressNumber, 10),
        CompanyAddressApto: applicant.workAddressApto,
        JobTitle: applicant.jobTitle,
        JobYears: parseInt(applicant.jobYears, 10),
        JobNetPay: parseInt(applicant.jobNetPay, 10),
        JobNetPayPesos: applicant.jobNetPayCurrency ? 0 : 1
      },

      CoApplicants: reqCoApplicants,

      RealState: knownRealEstate ? 1 : 0,
      RentArea: knownPropertyLocation ? 1 : 0,
      RentAreaText: knownPropertyLocationText === '' ? '-' : knownPropertyLocationText, // NOTE: No admite vacio el servicio
      RentValue: monthlyRentalAmount,
      RentValuePesos: monthlyRentalAmountCurrency ? 0 : 1,
      KnowUs: knowUs.value,
      KnowUsText: knowUs.label,
      Base64StringArray: base64StringArray,
      FileNames: fileNames,
      ConfidenceBroker: confidenceBroker.value,
      ConfidenceBrokerName: confidenceBroker.label,
    };

    dispatch(showInnerLoading(true));

    return Rental.sendMail(request).then(response => {
      if (response) {
        if (response.sended === "1") {
          dispatch(setRentalValue('finished', true));
          dispatch(setRentalValue('finishedStatus', {
            error: false,
            message: 'Su solicitud fue enviada correctamente'
          }));
        } else {
          dispatch(setRentalValue('finished', true));
          dispatch(setRentalValue('finishedStatus', {
            error: true,
            message: response.message
          }));
        }
      } else {
        dispatch(setRentalValue('finished', true));
        dispatch(setRentalValue('finishedStatus', {
          error: true,
          message: 'Error al enviar los datos.'
        }));
      }

      dispatch(showInnerLoading(false));
    });
  };
}
